import * as Yup from "yup";

import { Modal, OfficeButton } from "components";
import {
  SetApprovalStatus,
  SetApprovalStatusVariables,
} from "_graphql/mutation/kek/__generated__/SetApprovalStatus";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

import { ApproveOfferForm } from "components/forms";
import _ from "lodash";
import { approveOffer } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useKEKOffer } from "hooks/data/use-offers";
import { useMutation } from "@apollo/client";
import { useOfferComments } from "hooks/data/use-offer-comments";
import { withPermissions, wrapClick } from "utils";

export default function ApproveOfferContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParam = useAppSearch();
  const { params } = useAppLocation();
  const { offer, loading } = useKEKOffer({ offer_id: searchParam?.id || "" });
  const { comments, loading: loadingComments } = useOfferComments({
    offerId: searchParam?.id || "",
  });
  const [setStatus, { loading: settingStatus }] = useMutation<
    SetApprovalStatus,
    SetApprovalStatusVariables
  >(approveOffer, {
    refetchQueries: ["KEKOffers"],
  });
  const form = useFormik<any>({
    initialValues: {
      status: "",
      message: "",
      sendApprovalDocs: false,
    },
    onSubmit: async (variables) => {
      setStatus({
        variables: {
          messages: [variables?.message],
          offer_id: searchParam?.id || "",
          sendApprovalDocs: variables?.sendApprovalDocs || false,
          status: variables?.status || "",
        },
      })
        .then(() => {
          toast.success("Offer status changed successfully!");
          setOpen?.(false);
        })
        .catch((error) => {
          console.error("Error changing offer status:", error);
          toast.error("Failed to change offer status.");
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading || loadingComments}
      title="Approve Offer"
      description="Review and approve the offer details before proceeding."
      renderActions={() => (
        <>
          {withPermissions([
            "*:*",
            "offers:*",
            "offers:manage",
            "offers:approve",
          ])(
            <OfficeButton
              disabled={settingStatus}
              onClick={wrapClick(form.handleSubmit)}
            >
              {settingStatus ? "Submitting..." : "Submit"}
            </OfficeButton>
          )}
        </>
      )}
    >
      <ApproveOfferForm form={form} offer={offer} comments={comments} />
    </Modal>
  );
}
